import styled from "styled-components";

/**
 * Wrapper da Seção
 * Configura o background como uma imagem aleatória, com gradiente e espaçamento.
 */
export const SectionWrapper = styled.section.withConfig({
  shouldForwardProp: (prop) => !["backgroundImage", "height"].includes(prop),
})<{
  backgroundImage: string;
  height: string;
}>`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  color: ${({ theme }) => theme.colors.white};
  padding-right: ${({ theme }) => theme.spacing(4)};
  padding-left: ${({ theme }) => theme.spacing(4)};
  height: ${({ height }) => height};
  background-position: center;
  display: flex;
  flex-direction: column;
  background-size: cover;
  position: relative;
  width: 100%;
  & > * {
    z-index: 2; /* Garante que o conteúdo esteja sobre a imagem */
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.mediumBlue} -20%,
      rgba(0, 0, 0, 0) 100%
    ); /* Gradiente azul para transparente */
    z-index: 1;
  }
`;

/**
 * Conteúdo da Seção
 * Centraliza o conteúdo renderizado sobre o background.
 */
export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1640px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
`;
